import { Suspense } from 'react';
import { RawEditorOptions } from 'tinymce';
import './assets/fonts/style.scss';
import './index.scss';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './App';
import './i18n-config';
import Loader from './components/loader/Loader';

// custom window typing is needed for tiny config files
declare global {
  interface Window {
    tinyConfigs: {
      [key: string]: RawEditorOptions & {
        selector: undefined;
        target: undefined;
      };
    };
    tinyConfigList: string[];
  }
}

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <BrowserRouter>
    <Suspense fallback={<Loader />}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </BrowserRouter>,
);
